import { httpClient } from '@/modules/common/services/http/http-client';
import {
  RLPPageData,
  UpdateRLPStatusValues,
  UpdateRLPStatusResponse
} from './types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/trade`;
export const httpClientWithDefaultOptions = httpClient.withOptions({ baseURL });

export function getRLPStatus(): Promise<RLPPageData> {
  return httpClientWithDefaultOptions.get('/v2/getRLPStatus');
}

export function updateRLPStatus(
  status: UpdateRLPStatusValues
): Promise<UpdateRLPStatusResponse> {
  return httpClientWithDefaultOptions.put(
    '/v1/updateRLPStatus',
    {},
    {
      params: { status }
    }
  );
}
